module.exports = __webpack_public_path__ + "img/softwareLogo2.4bce9120.png";